import { openDB } from 'idb';

const DB_NAME = 'mywod-offline-db';
const DB_VERSION = 2; // Opgehoogd voor de nieuwe bank
const STORE_NAME_UNSYNCED = 'unsynced-workouts';
const STORE_NAME_BANK = 'offline-bank';

export const initDB = async () => {
    return openDB(DB_NAME, DB_VERSION, {
        upgrade(db, oldVersion, newVersion, transaction) {
            // Maak de unsynced kluis aan (als we van een schone lei starten)
            if (!db.objectStoreNames.contains(STORE_NAME_UNSYNCED)) {
                db.createObjectStore(STORE_NAME_UNSYNCED, { keyPath: 'id', autoIncrement: true });
            }
            // Maak de nieuwe workout-bank kluis aan
            if (!db.objectStoreNames.contains(STORE_NAME_BANK)) {
                db.createObjectStore(STORE_NAME_BANK);
            }
        },
    });
};

// --- FASE 2: UNSYNCED WORKOUTS ---
export const saveWorkoutLocally = async (workoutPayload) => {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME_UNSYNCED, 'readwrite');
    const timestamp = new Date().toISOString();
    await tx.store.add({ ...workoutPayload, _savedAt: timestamp });
    await tx.done;
};

export const getUnsyncedWorkouts = async () => {
    const db = await initDB();
    return db.getAll(STORE_NAME_UNSYNCED);
};

export const deleteUnsyncedWorkout = async (id) => {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME_UNSYNCED, 'readwrite');
    await tx.store.delete(id);
    await tx.done;
};

// --- FASE 3: OFFLINE BANK ---
export const saveOfflineBank = async (bankArray) => {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME_BANK, 'readwrite');
    await tx.store.put(bankArray, 'daily-bank'); // We overschrijven altijd met de nieuwste mix
    await tx.done;
};

export const getOfflineBank = async () => {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME_BANK, 'readonly');
    const bank = await tx.store.get('daily-bank');
    return bank || [];
};
